import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  var mp = '@media print';
  return {
    topRow: _objectSpread(_defineProperty({
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: componentTheme.titleShowWrapperBottomBorder
    }, mp, {
      display: 'none'
    }), props.isEditing && {
      borderBottom: 'solid',
      borderWidth: componentTheme.titleEditWrapperBorderWidth,
      borderColor: componentTheme.titleEditWrapperBorderColor
    }),
    flexContainer: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: '1',
      minWidth: '0'
    },
    label: {
      padding: componentTheme.labelPadding,
      paddingLeft: componentTheme.labelLeftPadding,
      paddingBottom: componentTheme.labelBottomPadding,
      fontSize: componentTheme.labelFontSize,
      color: componentTheme.labelColor
    },
    editButtonWrapper: {
      alignSelf: 'flex-end',
      marginRight: componentTheme.editButtonWrapperRightMargin,
      paddingTop: componentTheme.labelPadding
    }
  };
};
export default generateStyle;